var version = '4.0.0';
export { version };
export { default as Button } from './wui-button/src';
export { default as Badge } from './wui-badge/src';
export { default as Alert } from './wui-alert/src';
export { default as ButtonGroup } from './wui-button-group/src';
export { default as Input } from './wui-input/src';
export { default as Calendar } from './wui-calendar/src';
export { default as Form } from './wui-form/src';
export { default as Layout, Row, Col } from './wui-layout/src';
export { default as InputGroup } from './wui-input-group/src';
export { default as InputNumber } from './wui-input-number/src';
export { default as Checkbox } from './wui-checkbox/src';
export { default as Pagination } from './wui-pagination/src';
export { default as Progress } from './wui-progress/src';
export { default as Radio } from './wui-radio/src';
export { default as Switch } from './wui-switch/src';
export { default as Tooltip } from './wui-tooltip/src';
export { default as Dropdown } from './wui-dropdown/src';
export { default as DatePicker } from './wui-datepicker/src';
export { default as Collapse } from './wui-collapse/src';
export { default as Select } from './wui-select/src';
export { default as Icon } from './wui-icon/src';
export { default as Menu } from './wui-menu/src';
export { default as Upload } from './wui-upload/src';
export { default as Breadcrumb } from './wui-breadcrumb/src';
export { default as Message } from './wui-message/src';
export { default as Notification } from './wui-notification/src';
export { default as Popconfirm } from './wui-popconfirm/src';
export { default as Modal } from './wui-modal/src';
export { default as Tabs } from './wui-tabs/src';
export { default as Cascader } from './wui-cascader/src';
export { default as Spin } from './wui-spin/src';
export { default as Table } from './wui-table/src';
export { default as Tree } from './wui-tree/src';
export { default as Clipboard } from './wui-clipboard/src';
export { default as Rate } from './wui-rate/src';
export { default as Steps } from './wui-steps/src';
export { default as Timeline } from './wui-timeline/src';
export { default as Transfer } from './wui-transfer/src';
export { default as BackTop } from './wui-backtop/src';
export { default as Slider } from './wui-slider/src';
export { default as AutoComplete } from './wui-autocomplete/src';
export { default as Locale } from './wui-locale/src';
export { default as Popover } from './wui-popover/src';
export { default as Anchor } from './wui-anchor/src';
export { default as ColorPicker } from './wui-colorpicker/src';
export { default as Tag } from './wui-tag/src';
export { default as Affix } from './wui-affix/src';
export { default as Drawer } from './wui-drawer/src';
export { default as TreeSelect } from './wui-treeselect/src';
export { default as TimePicker } from './wui-timepicker/src';
export { default as Image } from './wui-image/src';
export { default as SvgIcon } from './wui-svgicon/src';
export { default as Carousel } from './wui-carousel/src';
export { default as Space } from './wui-space/src';
export { default as Empty } from './wui-empty/src';
export { default as Avatar } from './wui-avatar/src';
export { default as Card } from './wui-card/src'; // export { default as Overlay } from './wui-overlay/src';
// export { default as message } from './wui-message/src';//兼容antd小写
// export { default as notification } from './wui-notification/src';//兼容antd小写
// export { default as Transition } from './wui-transition/src';
// export { default as Navbar } from './wui-navbar/src';
// export { default as Animate } from './wui-animate/src';


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/index.js